import { getCurrentStorageName, getObjectFromSession, setObjectToSession } from '@/utils/session-utils';

import {
  SET_CENTROS_CUSTOS,
  SET_SOLICITANTES,
  SET_SEARCH_TEXT,
  SET_EMPRESA,
  SET_PRODUTO,
  SET_PROJETO,
  SET_GRUPO,
  SET_DATA_FINAL,
  SET_DATA_INICIAL,
  SET_DATA_ENTREGA_INICIAL,
  SET_DATA_ENTREGA_FINAL,
  SET_URGENCIA,
  SET_SHOW_ESPECIFICACAO,
  SET_COMPRADORES,
  SET_LOCAL_ENTREGA,
  SET_LIST_OPTIONS,
  SET_CURRENT_PAGE,
  SET_FILTER,
  SET_OFFSET,
  SET_CURRENT_SESSION_STATE,
  INIT_STATE,
  SET_SHOW_OBSERVACAO_EXTERNA,
  SET_SHOW_OBSERVACAO_INTERNA,
} from './mutations.type';

import { PREFIX_SESSION_STATE_NAME } from './constants';

export default {
  [SET_CENTROS_CUSTOS](state, centrosCustos) {
    state.centrosCustos = centrosCustos;
  },
  [SET_SOLICITANTES](state, solicitantes) {
    state.solicitantes = solicitantes;
  },
  [SET_SEARCH_TEXT](state, searchText) {
    state.searchText = searchText;
  },
  [SET_EMPRESA](state, empresa) {
    state.empresa = empresa;
  },
  [SET_LOCAL_ENTREGA](state, localEntrega) {
    state.localEntrega = localEntrega;
  },
  [SET_PRODUTO](state, produto) {
    state.produto = produto;
  },
  [SET_PROJETO](state, projeto) {
    state.projeto = projeto;
  },
  [SET_GRUPO](state, grupo) {
    state.grupo = grupo;
  },
  [SET_DATA_INICIAL](state, dataInicial) {
    state.dataInicial = dataInicial;
  },
  [SET_DATA_FINAL](state, dataFinal) {
    state.dataFinal = dataFinal;
  },
  [SET_DATA_ENTREGA_INICIAL](state, dataEntregaInicial) {
    state.dataEntregaInicial = dataEntregaInicial;
  },
  [SET_DATA_ENTREGA_FINAL](state, dataEntregaFinal) {
    state.dataEntregaFinal = dataEntregaFinal;
  },
  [SET_URGENCIA](state, urgencia) {
    state.urgencia = urgencia;
  },
  [SET_SHOW_ESPECIFICACAO](state, showEspecificacao) {
    state.showEspecificacao = showEspecificacao;
  },
  [SET_SHOW_OBSERVACAO_EXTERNA](state, showObservacaoExterna) {
    state.showObservacaoExterna = showObservacaoExterna;
  },
  [SET_SHOW_OBSERVACAO_INTERNA](state, showObservacaoInterna) {
    state.showObservacaoInterna = showObservacaoInterna;
  },
  [SET_COMPRADORES](state, compradores) {
    state.compradores = compradores;
  },
  [SET_CURRENT_PAGE](state, page) {
    state.listOptions.page = page;
  },
  [SET_FILTER](state, filter) {
    state.listOptions.filter = filter;
  },
  [SET_OFFSET](state, offset) {
    state.listOptions.offset = offset;
  },
  [SET_LIST_OPTIONS](state, listOptions) {
    state.listOptions = listOptions;
  },
  [SET_CURRENT_SESSION_STATE](state, ids) {
    const stateName = getCurrentStorageName(
      PREFIX_SESSION_STATE_NAME,
      ids.idCurrentEntidade,
      ids.idCurrentUser,
    );

    if (stateName) {
      setObjectToSession(stateName, state);
    }
  },
  [INIT_STATE](state, ids) {
    const currentStateName = getCurrentStorageName(
      PREFIX_SESSION_STATE_NAME,
      ids.idCurrentEntidade,
      ids.idCurrentUser,
    );
    const sessionObjectState = getObjectFromSession(currentStateName);

    state.searchText = sessionObjectState?.searchText || state.searchText;
    state.urgencia = sessionObjectState?.urgencia || state.urgencia;
    state.localEntrega = sessionObjectState?.localEntrega || state.localEntrega;
    state.centrosCustos = sessionObjectState?.centrosCustos || state.centrosCustos;
    state.produto = sessionObjectState?.produto || state.produto;
    state.projeto = sessionObjectState?.projeto || state.projeto;
    state.solicitantes = sessionObjectState?.solicitantes || state.solicitantes;
    state.fornecedor = sessionObjectState?.fornecedor || state.fornecedor;
    state.dataFinal = sessionObjectState?.dataFinal || state.dataFinal;
    state.dataInicial = sessionObjectState?.dataInticial || state.dataInticial;
    state.grupo = sessionObjectState?.grupo || state.grupo;
    state.compradores = sessionObjectState?.compradores || state.compradores;
    state.showEspecificacao = sessionObjectState?.showEspecificacao || state.showEspecificacao;
    state.showObservacaoExterna = sessionObjectState?.showObservacaoExterna
      || state.showObservacaoExterna;
    state.showObservacaoInterna = sessionObjectState?.showObservacaoInterna
      || state.showObservacaoInterna;
    state.listOptions = sessionObjectState?.listOptions || state.listOptions;
  },
};
